import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { AbstractControl, NgControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Directive({
  selector: 'input[numberInput]',
})
export class NumberInputDirective {

  @Input() max?: bigint;
  @Input() min?: bigint;

  /** html要素 */
  private element: HTMLInputElement;
  /** 入力の数値(入力なしの場合はnull) */
  private value?: bigint = null;
  /** フォーカス有無フラグ */
  private isFocus = false;

  constructor(
    private elementRef: ElementRef,
    private control: NgControl,
  ) {
    this.element = this.elementRef.nativeElement;
  }

  ngOnInit() {
    // バリデーション
    this.control.control.addValidators(this.validations(this.max, this.min));
    // 入力中、リセット時のコールバック設定
    this.control.valueChanges.subscribe((v) => this.updateView(v));
    // 初期表示
    this.control.control.setValue(this.control.value);
  }

  // 桁区切りの表示更新（数値変換→文字列表示）
  private updateView(value?) {
    // 数字と先頭のマイナス以外を削除
    let strValue = removeUnusedChar(this.element.value);

    if (strValue == '-') {
      // マイナス記号のみの場合
      this.element.value = strValue;
    } else {
      // フォーカス位置を取得
      let selectRange = this.element.selectionStart;

      // メンバ変数に数値として格納。空文字の場合はnullにする。
      this.value = strValue?.length > 0 ? BigInt(strValue) : null;
      // 数値から変換(フォーカスあり→カンマなし、フォーカスなし→カンマあり)
      this.element.value = this.value?.toLocaleString('ja-JP', { useGrouping: !this.isFocus }) ?? '';

      // FormControl内値を更新
      if (this.value) {
        if (this.control.value != this.value.toString() || typeof this.control.value == 'string') {
          this.control.control.setValue(Number(this.value));
        }
      } else {
        if (this.control.value != this.value) {
          this.control.control.setValue(this.value);
        }
      }

      // フォーカス位置を設定
      if (value) {
        selectRange -= value.length - this.element.value.length;
        this.element.setSelectionRange(selectRange, selectRange);
      }
    }
  }

  // フォーカス時
  @HostListener("focus")
  ngFocus() {
    // フラグ更新
    this.isFocus = true;
    this.updateView();
  }
  //* フォーカスアウト時
  @HostListener("blur")
  onBlur() {
    // フラグ更新
    this.isFocus = false;

    this.updateView();
    // マイナスのみ
    if (this.element.value == '-') {
      this.control.control.setValue(undefined);
    }
  }

  /** カスタムバリデーション */
  validations(max?: bigint, min?: bigint): ValidatorFn {
    return function validate(control: AbstractControl): ValidationErrors {
      // BigIntに変換
      let value: bigint;
      try {
        value = BigInt(removeUnusedChar(control.value?.toString()));
      } catch (error) {
        return { invalidAttribute: true };
      }

      if (max < value) {//最大値
        return { max: true };
      } else if (min > value) {//最小値
        return { min: true };
      }

    }
  }

}
function removeUnusedChar(bigintStr: string): string {
  return bigintStr?.replace(/[^-\d]/g, '').replace(/(?<=.)-/g, '') ?? '';
}
